import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues, change as onChange } from 'redux-form';
import { FlatButton, Dialog, List, ListItem, Toggle } from 'material-ui';
import { red500, green500, orange500 } from 'material-ui/styles/colors';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Checkmark from 'material-ui/svg-icons/action/check-circle';
import { CREATE, UPDATE, showNotification as showNotificationAction, translate as t } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import { get } from 'lodash';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
import addUploadCapability from '../../client/addUploadCapability';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = addUploadCapability(kunalClient(API_BASE_URL, kunal));

const ConfirmDialog = ({ open, record, toggle, onSubmit, translate, change }) => {
  const attributes = [
    { key: 'title', msg: 'noTitleProvided', fn: (value) => value.findIndex((val) => val && !!val.content) !== -1 },
    { key: 'subtitle', msg: 'noSubTitleProvided', fn: (value) => value.findIndex((val) => val && !!val.content) !== -1, color: orange500 },
    { key: 'code', msg: 'noCodeProvided', fn: (value) => value && value.length > 0 },
    { key: 'stations', msg: 'noStations', fn: (value) => value && value.length > 0 },
    { key: 'mainImageUrl', msg: 'noImage', fn: (value) => Object.keys(value).length > 0, color: red500 },
    { key: 'allergens', msg: 'noAllergens', fn: (value) => value && value.length > 0, color: red500 },
    { key: 'markets', msg: 'noValidMarkets', fn: (value) => value.some((val) => val.vat && val.suggestedPrice) },
    { key: 'markets', msg: 'invalidMarkets', fn: (value) => value.some((val) => val.vat && val.suggestedPrice) && !value.some((val) => (val.vat && !val.suggestedPrice) || (!val.vat && val.suggestedPrice)), color: orange500 },
    { key: 'frozen', msg: 'frozenProduct', fn: (value) => value },
  ];

  const onFrozenConfirm = (event, checked) => {
    change('record-form', 'removeFromAssortment', checked);
  };

  return (
    <Dialog
      contentStyle={{ width: '400px' }}
      autoScrollBodyContent
      open={open}
      actions={[
        <FlatButton label="Cancel" onClick={toggle} />,
        <FlatButton label="Confirm" onClick={onSubmit} />,
      ]}
    >
      <List>
        {attributes.map((attribute) => {
          const valid = attribute.fn(get(record, attribute.key) || []);
          if (attribute.key === 'frozen' && (valid === false || Array.isArray(valid) === true)) {
            return '';
          }

          return (
            attribute.key === 'frozen' && valid === true ? (
              <ListItem
                key={`${attribute.key}_${attribute.msg}`}
                primaryText={<div>{translate(`resources.products.${attribute.key}`)}</div>}
                rightToggle={<Toggle checked={record.removeFromAssortment} onToggle={onFrozenConfirm} />}
              />
            ) : (
              <ListItem
                key={`${attribute.key}_${attribute.msg}`}
                primaryText={<div style={valid ? { color: green500 } : { color: attribute.color || red500 }}>{translate(`resources.products.fields.${attribute.key}`)}</div>}
                rightIcon={valid ? <Checkmark style={{ top: '1px' }} color={green500} /> : <ActionInfo color={attribute.color || red500} />}
                open
                secondaryText={valid ? null : <div style={{ color: attribute.color || red500 }}>{translate(`publishMessages.${attribute.msg}`)}</div>}
              />
            )
          );
        })}
      </List>
    </Dialog>
  );
};

class ProductSaveButton extends Component {
  constructor() {
    super();
    this.state = {
      confirmOpen: false,
    };
  }

  handleClick = () => {
    const { action, push, record, showNotification } = this.props;
    const updatedRecord = { ...record, updatedAt: new Date() };

    restClient(action === 'edit' ? UPDATE : CREATE, 'products', { id: record.id, data: updatedRecord })
      .then(() => {
        showNotification('Product saved');
        push('/products');
      })
      .catch((e) => {
        showNotification(`Error: ${e && e.body ? e.body.error : e.message ? e.message : 'unknown'}`, 'warning');
      });
  }

  openConfirm = () => this.setState({ confirmOpen: !this.state.confirmOpen });

  render() {
    // eslint-disable-next-line no-shadow
    const { translate } = this.props;
    return (
      <div>
        <FlatButton primary label={translate('save')} onClick={() => this.openConfirm()} />
        <ConfirmDialog
          open={this.state.confirmOpen}
          toggle={() => this.openConfirm()}
          onSubmit={() => this.handleClick()}
          {...this.props}
        />
      </div>
    );
  }
}
ProductSaveButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};
const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }),
  {
    showNotification: showNotificationAction,
    push: pushAction,
    change: onChange,
  }
)(t(ProductSaveButton));
